import $ from 'jquery';
import _noop from 'lodash/noop';

const FULL_SCREEN = [
  'fullscreenchange',
  'mozfullscreenchange',
  'webkitfullscreenchange',
  'msfullscreenchange',
].join(' ');

const TRANSITION_END = [
  'transitionend',
  'webkitTransitionEnd',
  'oTransitionEnd',
  'MSTransitionEnd',
].join(' ');

const VISIBILITY_CHANGE = [
  'visibilitychange',
  'webkitvisibilitychange',
  'mozvisibilitychange',
  'msvisibilitychange',
].join(' ');

export const oneTransitionEnd = ($elem, cb) => {
  return $elem.one(TRANSITION_END, cb);
};

export const onFullScreen = (cb = _noop) => {
  $(document).on(FULL_SCREEN, cb);
};

export const offFullScreen = () => {
  $(document).off(FULL_SCREEN);
};

// https://stackoverflow.com/a/20711706/696130
export const onVisibilityChange = (cb = _noop) => {
  $(document).on(VISIBILITY_CHANGE, () => {
    cb(
      !(
        document.hidden ||
        document.mozHidden ||
        document.msHidden ||
        document.webkitHidden
      )
    );
  });
};
